import { render, staticRenderFns } from "./benefits-menu.vue?vue&type=template&id=384e815f"
import script from "./benefits-menu.vue?vue&type=script&lang=js"
export * from "./benefits-menu.vue?vue&type=script&lang=js"
import style0 from "./benefits-menu.vue?vue&type=style&index=0&id=384e815f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports